import xhr from 'xhr'
import RA from 'ra-config'

// Maintain a cache. Data updates monthly and this saves on parse time
// for large JSON files
const CACHE = {}
const ROOT = `${process.env.DATA_PATH || ''}${RA.app.dataPath}`

export default function request(path, options = {}) {
  // Prevent double slashes
  const url = `${ROOT}/USD/${path}`.split(/\/+/).join('/')

  return function(action) {
    if (CACHE[url]) {
      return action.resolve(CACHE[url])
    }

    action.open(options.initial)

    xhr({ url, json: true }, function(error, response, body) {
      if (error) {
        return action.reject(error)
      }

      CACHE[url] = body

      action.resolve(body)
    })
  }
}



// WEBPACK FOOTER //
// ./src/request.js